var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('FontAwesomeIcon',{class:_vm.status,attrs:{"icon":_vm.icon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }